import apiBase from "../../api/axios";

const BASE = "v1/preguntas-talento-global";

const qs = (params = {}) => {
  const parts = Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null && v !== "")
    .map(([k, v]) => `${k}=${encodeURIComponent(v)}`);
  return parts.length ? `?${parts.join("&")}` : "";
};

// ============================================================
// TIPOS DE FORTALEZA (choices del mixin)
// ============================================================

export const getTiposFortalezaService = async () => {
  const r = await apiBase.get(`${BASE}/tipos-fortaleza/`);
  return r.data;
};

// Tipos de sub-frase (fortaleza / aplicación)
export const getTiposSubFraseService = async () => {
  const r = await apiBase.get(`${BASE}/tipos-sub-frase/`);
  return r.data;
};

// ============================================================
// FRASES
// ============================================================

export const getFrasesService = async ({ page = 1, search = "", tipo_fortaleza, is_active } = {}) => {
  const r = await apiBase.get(`${BASE}/frases/${qs({ page, search, tipo_fortaleza, is_active })}`);
  return r.data;
};

export const createFraseService = async (payload) => {
  const r = await apiBase.post(`${BASE}/frases/`, payload);
  return r.data;
};

export const updateFraseService = async (id, payload) => {
  const r = await apiBase.put(`${BASE}/frases/${id}/`, payload);
  return r.data;
};

export const toggleFraseActiveService = async (id) => {
  const r = await apiBase.post(`${BASE}/frases/${id}/toggle_active/`);
  return r.data;
};

export const getFrasesSelectorService = async ({ tipo_fortaleza, search = "" } = {}) => {
  const r = await apiBase.get(`${BASE}/selectores/frases/${qs({ tipo_fortaleza, search })}`);
  return r.data;
};

// ============================================================
// SUB-FRASES
// ============================================================

export const getSubFrasesService = async ({
  page = 1, search = "", frase, talento, tipo_fortaleza, tipo, is_active,
} = {}) => {
  const r = await apiBase.get(
    `${BASE}/sub-frases/${qs({ page, search, frase, talento, tipo_fortaleza, tipo, is_active })}`
  );
  return r.data;
};

export const createSubFraseService = async (payload) => {
  const r = await apiBase.post(`${BASE}/sub-frases/`, payload);
  return r.data;
};

export const updateSubFraseService = async (id, payload) => {
  const r = await apiBase.put(`${BASE}/sub-frases/${id}/`, payload);
  return r.data;
};

export const toggleSubFraseActiveService = async (id) => {
  const r = await apiBase.post(`${BASE}/sub-frases/${id}/toggle_active/`);
  return r.data;
};

// ============================================================
// OPCIONES SÍ/NO (globales, siempre 2)
// ============================================================

export const getOpcionesRespuestaService = async () => {
  const r = await apiBase.get(`${BASE}/opciones-respuesta/`);
  return r.data;
};

export const updateOpcionRespuestaService = async (id, payload) => {
  const r = await apiBase.patch(`${BASE}/opciones-respuesta/${id}/`, payload);
  return r.data;
};
